/*
 * @Description:
 * @Date: 2022-12-07 09:24:26
 */
import { checkoutPhone as checkoutPhoneAjax } from '@/api/ajax';
const parent = document.body;
const maxWidth = document.body.offsetWidth;

// const getScorllTableDom = dom => {
//   let maxLoopCount = 5; // 避免找不到，导致死循环
//   while (
//     maxLoopCount > 0 &&
//     dom.className.indexOf('el-table__body-wrapper') == -1
//   ) {
//     dom = dom.parentElement;
//     maxLoopCount--;
//   }
//   console.log(dom.scrollTop);
//   return dom || document.body;
// };

const checkRowHasClassName = (dom, targetClassName) => {
  let maxLoopCount = 5; // 避免找不到，导致死循环
  while (
    maxLoopCount > 0 &&
    dom.className.indexOf(targetClassName) == -1 &&
    dom.className.indexOf('el-table__row') == -1
  ) {
    dom = dom.parentElement;
    maxLoopCount--;
  }
  return dom.className.indexOf(targetClassName) > -1;
};

export const getUnqualifiedRowConfig = ({
  // eslint-disable-next-line no-unused-vars
  row,
  rowIndex,
  isNotUnqualified = true, // 是否合格
  unqualifiedMsg = '数据监测不合格，系统已自动拦截'
}) => {
  // zbBlackStatus 众邦黑名单 0否 1是(普通) 2是(永久)
  // superviseStatus  监管状态 1正常  2待确认 3停用
  // if ('superviseStatus' in row && row.superviseStatus != 3) return '';
  // if (!('superviseStatus' in row) && isNotUnqualified) return '';
  if (isNotUnqualified) return '';
  let tips = unqualifiedMsg || '数据监测不合格，系统已自动拦截';
  let tipsDomWidth = 200;
  if (row.zbBlackStatus === 2) {
    tips = '银行账户异常';
    tipsDomWidth = 92;
  }
  if (row.superviseStatus === 3) {
    tips = '数据监测不合格，系统已自动拦截';
  }
  if (row.zbBlackStatus === 2 && row.superviseStatus === 3) {
    tips = '【银行账户异常】-【数据监测不合格，系统已自动拦截】';
    tipsDomWidth = 326;
  }
  const className = `unqualified-${rowIndex}-${Date.now()}`;
  setTimeout(() => {
    const unqualifiedDom = document.querySelector(
      `.el-table__body-wrapper .unqualified.${className}`
    );
    if (!unqualifiedDom) return;
    unqualifiedDom.onmousemove = e => {
      if (!checkRowHasClassName(e.target, className)) return;
      const rect = unqualifiedDom
        ? unqualifiedDom.getBoundingClientRect()
        : { top: 0, height: 0 };
      const top = rect.top + rect.height + 8;
      const left = Math.min(e.x - tipsDomWidth / 2, maxWidth - tipsDomWidth);
      const tipsDom = parent.querySelector('.custom-unqualified-tips');
      if (tipsDom) {
        tipsDom.innerHTML = tips;
        tipsDom.style.display = 'block';
        tipsDom.style.left = `${left}px`;
        tipsDom.style.top = `${top}px`;
        tipsDom.style.width = `${tipsDomWidth}px`;
        tipsDom.innerHTML = tips;
      } else {
        const div = document.createElement('div');
        div.className = 'custom-unqualified-tips el-tooltip__popper is-dark';
        div.innerHTML = tips;
        div.style.left = `${left}px`;
        div.style.top = `${top}px`;
        div.style.minWidth = `${tipsDomWidth}px`;
        parent.appendChild(div);
      }
    };
    unqualifiedDom.onmouseleave = () => {
      const tipsDom = parent.querySelector('.custom-unqualified-tips');
      if (tipsDom) {
        tipsDom.style.display = 'none';
      }
    };
  }, 0);
  return `unqualified ${className}`;
};

export const checkoutPhone = (rule, value, callback) => {
  checkoutPhoneAjax({
    phone: value
  })
    .then(res => {
      res.data.data != 1
        ? callback()
        : callback(new Error('系统检测该人员数据异常已被系统拦截无法添加'));
    })
    .catch(() => {
      callback(new Error('系统检测该人员数据异常已被系统拦截无法添加'));
    });
};
